<template>
    <div class="form-authorizations-container vx-row mb-6">
        <div class="vx-col w-full ml-4">
            <div class="vx-row mb-6" v-show="!reduced">
                <b v-if="evaluator">Périmètre de l'évaluateur externe</b>
                <b v-else>Personne(s) additionnelle(s) au périmètre de l'évaluateur tiers</b>
            </div>

            <!-- Source de l'évaluation -->
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>Source de l'évaluation :</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full px-0">
                    <vs-input
                        v-model="value.eval_source"
                        name="userEmail"
                        type="email"
                        class="w-full"
                    />
                </div>
            </div>

            <div class="vx-row mb-6" v-show="!reduced">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>Personnes :</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                    <Multiselect
                        v-if="(evaluator && groupedEmployeesByEstablishmentsForEvaluators.length > 0) || (!evaluator && groupedEmployeesByEstablishmentsForNoNEvaluators.length > 0)"
                        v-model="value.employees"
                        :options="evaluator ? groupedEmployeesByEstablishmentsForEvaluators : groupedEmployeesByEstablishmentsForNoNEvaluators"
                        :multiple="true"
                        group-values="employees"
                        group-label="establishment"
                        :group-select="true"
                        placeholder="Recherche ..."
                        track-by="id"
                        label="name"
                        select-label=""
                        select-group-label="L'établissement"
                        selected-label=""
                        deselect-label=""
                        deselect-group-label=""
                    >
                        <span slot="noResult">Aucun résultat.</span>
                    </Multiselect>
                </div>
            </div>

            <!-- <div class="vx-row mb-6" v-if="value.employees.length">
                <div class="vx-col sm:w-1/5 w-full" >
                    <b>{{ !reduced ? '' : 'Périmètre de l\'évaluateur*' }}</b>
                </div>
                <div class="vx-col sm:w-1/3 w-full" v-if="!reduced || reducedType === 'experience'">
                    <span>Poste(s)</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full" v-if="!reduced || reducedType === 'occupation'">
                    <span>Métier(s)</span>
                </div>
                <div class="vx-col sm:w-1/5 w-full" >
                    <span>Compétences</span>
                </div>
                <div class="vx-col sm:w-1/5 w-full" >
                    <span>Questionnaire</span>
                </div>
            </div> -->
            <div
                class="vx-row mb-6"
                v-for="(employee, index) in value.employees"
                :key="index"
            >
                <div class="vx-col sm:w-3/12 w-full">
                    <div v-show="!reduced">
                        <span>({{ employee.id }}) {{ employee.name }}</span>
                    </div>
                    <!-- Type d'évaluation -->
                    <div>
                        <label>Évaluation demandée*</label>
                        <Multiselect
                            v-model="employee.eval_types"
                            :options="evalTypes"
                            :multiple="false"
                            name="eval_types"
                            track-by="slug"
                            label="title"
                            placeholder="Recherche ..."
                            select-label=""
                            selected-label=""
                            deselect-label=""
                        />
                    </div>
                </div>
                    {{ log(employee.jobsToEvaluate, employee.experiencesToEvaluate, employee.occupationsToEvaluate) }}
                <div class="vx-col sm:w-4/12 w-full" v-if="!reduced || reducedType === 'experience'">
                    <div>
                        <label>Poste(s)</label>
                        <Multiselect
                            v-model="employee.jobsToEvaluate"
                            :name="'employee.' + employee.id + '.jobs'"
                            :options="employee.jobs || []"
                            :multiple="true"
                            placeholder="Postes à considérer ..."
                            track-by="id"
                            label="title"
                            select-label=""
                            selected-label=""
                            deselect-label=""
                        >
                            <span slot="noResult">Aucun résultat.</span>
                            <span slot="noOptions">La liste est vide.</span>
                        </Multiselect>
                    </div>

                    <div class="mt-2">
                        <label>Autres expérience(s)</label>
                        <Multiselect
                            v-model="employee.experiencesToEvaluate"
                            :name="'employee.' + employee.id + '.experiences'"
                            :options="employee.experiences || []"
                            :multiple="true"
                            placeholder="Expériences à considérer ..."
                            track-by="id"
                            label="name"
                            select-label=""
                            selected-label=""
                            deselect-label=""
                        >
                            <span slot="noResult">Aucun résultat.</span>
                            <span slot="noOptions">La liste est vide.</span>
                        </Multiselect>
                    </div>

                </div>
                <div class="vx-col sm:w-4/12 w-full" v-if="!reduced || reducedType === 'occupation'">
                    <div>
                        <label>Métier(s)</label>
                        <Multiselect
                            v-model="employee.occupationsToEvaluate"
                            :name="'employee.' + employee.id + '.occupations'"
                            :options="employee.occupations || []"
                            :multiple="true"
                            placeholder="Métiers à considérer ..."
                            track-by="id"
                            label="title"
                            select-label=""
                            selected-label=""
                            deselect-label=""
                        >
                            <span slot="noResult">Aucun résultat.</span>
                            <span slot="noOptions">La liste est vide.</span>
                        </Multiselect>
                    </div>
                    <div class="mt-2">
                        <label>Autre expérience(s)</label>
                        <Multiselect
                            v-model="employee.experiencesToEvaluate"
                            :name="'employee.' + employee.id + '.experiences'"
                            :options="employee.experiences || []"
                            :multiple="true"
                            placeholder="Expériences à considérer ..."
                            track-by="id"
                            label="name"
                            select-label=""
                            selected-label=""
                            deselect-label=""
                        >
                            <span slot="noResult">Aucun résultat.</span>
                            <span slot="noOptions">La liste est vide.</span>
                        </Multiselect>
                    </div>
                </div>

                <div class="vx-col sm:w-2/12 w-full">
                    <label>Compétences</label>
                    <vs-switch
                        v-model="employee.eval_skills"
                        name="eval_skills"
                    />
                </div>
                <div class="vx-col sm:w-3/12 w-full">
                    <label>Questionnaire*</label>
                    <br>
                    <Multiselect
                        v-model="employee.questionnaire"
                        name="questionnaire"
                        :options="questionnaires.data"
                        placeholder="Choisir..."
                        track-by="id"
                        label="name"
                        select-label=""
                        selected-label=""
                        deselect-label=""
                        :loading="questionnaires.loading"
                    >
                        <span slot="noResult">Aucun résultat.</span>
                        <span slot="noOptions">La liste est vide.</span>
                    </Multiselect>
                </div>
                <div class="vx-col w-full">
                    <vs-collapse>
                        <vs-collapse-item>
                        <div slot="header">
                            Ajouter un objectif
                        </div>
                            <vs-textarea v-model="employee.goals" height="73" />
                        </vs-collapse-item>
                    </vs-collapse>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { loadRatingQuestionnaires, loadExperienceTypes } from "@components/services/resources.js";
import gridMixin from "@/mixins/gridMixin";

export default {
    name: "UserEvaluatorForm",
    components: {
        Multiselect
    },
    mixins: [gridMixin],
    props: {
        value: {
            required: true,
            type: Object
        },
        establishmentsList: {
            required: false,
            default: () => []
        },
        servicesList: {
            required: false,
            default: () => []
        },
        evaluator: {
            required: true,
        },
        reduced: {
            required: false,
            type: Boolean,
            default: false,
        },
        reducedFor: {
            required: false,
        },
        reducedType: {
            required: false,
            type: String,
        }
    },
    data() {
        return {
            log: console.log,
            loadRatingQuestionnaires,
            loadExperienceTypes,
            employees: [],
            employeesLoading: true,
            evalTypes: [
                { slug: "intern", title: "Evaluation interne" },
                { slug: "client", title: "Evaluation client" },
                { slug: "rae", title: "RAE" },
                { slug: "mixed", title: "Evaluation croisée" },
                { slug: "stage", title: "Evaluation Stage" }
            ],
            questionnaires: {
                data: [],
                loading: false
            },
            // experienceTypes: {
            //     data: [],
            //     loading: false
            // }
        };
    },
    async created() {
        this.$vs.loading();
        await Promise.all([
            //this.fetchExperienceTypes(),
            this.fetchRatingQuestionnaires(),
            this.fetchEmployees(),
        ]);
        this.$vs.loading.close();
    },
    computed: {
        groupedEmployeesByEstablishmentsForEvaluators() {
            let toShow = [];
            let servs = [];

            this.establishmentsList.forEach(e => {
                servs = this.servicesList ? this.servicesList.filter(service => service.establishment_id === e.id) : [];
                toShow.push({
                    establishment: e.name,
                    employees: this.employees
                        ? this.employees
                            .filter(em => servs.map(s => s.id).includes(em.services[0].id))
                            .map(employee => {
                                
                                return {
                                    id: employee.id,
                                    mobility: employee?.mobility,
                                    mobility_id: employee?.mobility_id,
                                    first_name: employee?.first_name,
                                    last_name: employee?.last_name,
                                    jobs: employee.jobs,
                                    occupations: employee.occupations,
                                    name: `${employee.last_name.toUpperCase()} ${employee.first_name}`,
                                    jobsToEvaluate: this.getJobToEvaluate(employee),
                                    occupationsToEvaluate: this.getOccupationToEvaluate(employee),
                                    eval_types: employee.eval_types,
                                    eval_skills: true,
                                    questionnaire: this.getQuestionnaire(employee),
                                    goals: employee.goals
                                };
                            })
                        : []
                });
            });

            return toShow;
        },

        groupedEmployeesByEstablishmentsForNoNEvaluators() {
            let toShow = [];
            let servs = [];

            let servicesNotInPerimeter = this.servicesList ? this.services.filter(s => !this.servicesList.map(sL => sL.id).includes(s.id)) : this.services

            this.establishmentsList.forEach(e => {
                servs = servicesNotInPerimeter ? servicesNotInPerimeter.filter(service => service.establishment_id === e.id) : [];

                toShow.push({
                    establishment: e.name,
                    employees: this.employees
                        ? this.employees
                            .filter(e => servs.map(s => s.id).includes(e.services[0]))
                            .map(employee => {
                                
                                return {
                                    id: employee.id,
                                    mobility: employee?.mobility,
                                    mobility_id: employee?.mobility_id,
                                    first_name: employee?.first_name,
                                    last_name: employee?.last_name,
                                    jobs: employee.jobs,
                                    occupations: employee.occupations,
                                    name: `${employee.last_name.toUpperCase()} ${employee.first_name}`,
                                    jobsToEvaluate: this.getJobToEvaluate(employee),
                                    occupationsToEvaluate: this.getOccupationToEvaluate(employee),
                                    eval_types: employee.eval_types,
                                    questionnaire: this.getQuestionnaire(employee),
                                    goals: employee.goals
                                };
                            })
                        : []
                });
            });

            return toShow;
        }
    },

    watch: {
        value: {
            handler() {
                this.$emit("input", this.value);
            },
            deep: true
        }
    },

    methods: {

        fetchRatingQuestionnaires() {
            this.questionnaires.loading = true;

            return this.loadRatingQuestionnaires().then((response) => {
                this.questionnaires.data = response.data;
                this.questionnaires.loading = false;

                this.value.employees.forEach((employee) => {
                    if (employee.questionnaire_id) {
                        employee.questionnaire = this.questionnaires.data.find(q => q.id == employee.questionnaire_id);
                    }
                    else {
                        employee.questionnaire = this.questionnaires.data[0]
                    }
                })
            })
        },
        
        fetchEmployees() {
            return window
                .axios({
                    method: "get",
                    url: "/api/gestion/employees",
                    params: {
                        perpage: 9999,
                        include: [
                            'currentOccupations', 
                            'currentJobs',
                            'currentGrids.sector',
                            'services.establishment', 
                            'experiences.experienceType'
                        ],
                        filter: this.reducedFor ? 'id|=|'+this.reducedFor : undefined,
                        updatable: 'true', //only ones auth user has permissions to update
                    }
                })
                .then(response => {
                    this.employees = response.data.data;

                    if (this.reduced) {
                        let employee = this.employees.find(e => e.id === +this.reducedFor)

                        this.value.employees = [{
                            id: employee.id,
                            mobility: employee?.mobility,
                            mobility_id: employee?.mobility_id,
                            first_name: employee?.first_name,
                            last_name: employee?.last_name,
                            current_jobs: employee.current_jobs,
                            current_occupations: employee.current_occupations,
                            current_grids: employee.current_grids,
                            name: `${employee.last_name.toUpperCase()} ${employee.first_name}`,
                            jobsToEvaluate: this.getJobToEvaluate(employee),
                            occupationsToEvaluate: this.getOccupationToEvaluate(employee),
                            experiences: this.filterExperiences(employee.experiences, this.reducedType),
                            experiencesToEvaluate: this.filterExperiences(employee.experiences, this.reducedType),
                            eval_types: employee.eval_types,
                            eval_skills: true,
                            questionnaire: this.getQuestionnaire(employee),
                            goals: ''
                        }];
                    }
                    this.employeesLoading = false;
                })
                .catch(err => {
                    console.log(err);
                    this.notifyError(err, `Une erreur est survenue`);
                });
        },

        getJobToEvaluate(employee) {
            let jobsToEvaluate = [];

            if (!this.reduced || this.reducedType === 'experience') {
                employee.current_jobs.forEach(j => {
                    jobsToEvaluate.push({
                        id: j.id,
                        title: j.title,
                        resource: 'Job'
                    })
                })

                // On ajoute les grilles de type Job
                this.filterGridsByJobType(employee.current_grids).forEach(g => {
                    jobsToEvaluate.push({
                        id: g.id,
                        title: `${g.title} (${g.sector.title})`,
                        resource: 'Grid'
                    })
                })
            }

            return jobsToEvaluate;
        },

        getOccupationToEvaluate(employee) {
            let occupationsToEvaluate = [];

            if ((!this.reduced || this.reducedType === 'occupation')) {
                employee.current_occupations.forEach(o => {
                    occupationsToEvaluate.push({
                        id: o.id, 
                        title: o.title,
                        admin_id: o.admin_id,
                        resource: o.admin_id ? 'AdminOccupation' : 'Occupation'
                    })
                })

                // On ajoute les grilles de type Occupation
                this.filterGridsByOccupationType(employee.current_grids).forEach(g => {
                    occupationsToEvaluate.push({
                        id: g.id,
                        title: `${g.title} (${g.sector.title})`,
                        admin_id: null,
                        resource: 'Grid'
                    })
                })
            }

            return occupationsToEvaluate;
        },

        getQuestionnaire(employee) {
            let questionnaire = this.questionnaires.data[0]
            if (employee.questionnaire_id) {
                questionnaire = this.questionnaires.data.find(q => q.id == employee.questionnaire_id)
            }

            return questionnaire;
        },

        filterExperiences(experiences, type) {
            
            const categories = type == 'experience' ? [0, 1] : [6];

            const filteredExperiences = experiences.filter(e => {
                const experienceCategory = categories.includes(e.experience_type.category);
                const withoutEndDate = !e.end_date;
                const endDateIsFuture = (new Date(e.end_date).getTime() > (new Date).getTime());
    
                return experienceCategory && (withoutEndDate || endDateIsFuture);
            })
            
            //Expérience (ancien oldOccupation)
            return filteredExperiences.map(e => {

                return {
                    id: e.id,
                    name: e.name,
                    type: e.experience_type.slug
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped></style>
